import { PageRef } from 'providers/page-ref';

export type ExerciseStatsPageParams = {
  id: string;
  mode?: 'instructions' | 'log' | 'settings';
};

export const IExerciseStatsPage: PageRef<ExerciseStatsPageParams, void> = {
  pageName: 'ExerciseStatsPage',
} as PageRef<ExerciseStatsPageParams, void>;
